module.exports = __webpack_public_path__ + "bbf72f714eb2d229ff50b75db0004a26.png";